export const API_CHANGE_APPROVED_STATUS_PATH = API_BASE + 'users/approve';
export const API_FETCH_MATCHES_PATH = API_BASE + 'matches';
export const API_UPDATE_MATCHES_PATH = API_BASE + 'matches/update';
export const API_CHANGE_MATCHES_APPROVED_STATUS_PATH = API_BASE + 'matches/approve';
export const API_GET_USER_SESSION_PATH = API_BASE + 'users/current';
export const API_LOGOUT_PATH = API_BASE + 'logout';
export const API_LOGIN_PATH = API_BASE + 'login';

export const GET_SESSION = 'GET_SESSION';

export const CANDIDATES_NS = 'candidates'
export const VACANCIES_NS = 'vacancies'
export const RECRUITERS_NS = 'recruiters'
export const MATCHES_NS = 'matches'
export const USERS_NS = 'users'

export const TOGGLE_USER_APPROVED = 'TOGGLE_USER_APPROVED';

export const UPDATE_MATCHES_REQUESTED = 'UPDATE_MATCHES_REQUESTED';
export const UPDATE_MATCHES_WITH = 'UPDATE_MATCHES_WITH';
export const UPDATE_MATCHES_STARTED = 'UPDATE_MATCHES_STARTED';
export const UPDATE_MATCHES_ENDED = 'UPDATE_MATCHES_ENDED';

export const TOGGLE_MATCH_APPROVED = 'TOGGLE_MATCH_APPROVED';

export const LOGIN_META = 'LOGIN_META';
export const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED';
export const LOGOUT_SUCCEEDED = 'LOGOUT_SUCCEEDED';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

// We should NOT be hard-coding this
export const MATCH_TOTAL = 275;




// WEBPACK FOOTER //
// ./src/constants/index.js